<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 18:22:39
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-07 11:31:22
 * @Description: 出借记录
 -->
<template>
  <div class="lend-record-wrapper">
    <div class="text-wrapper">
      <p class="text">
        目前投标总额：
        <span class="money">{{ baseInfo.money }}元</span>
      </p>
      <p class="line">|</p>
      <p class="text">
        剩余投标总额：
        <span class="money">{{ baseInfo.remainMoney }}元</span>
      </p>
    </div>
    <template v-if="lendList.length > 0">
      <el-table :data="lendList" stripe class="table-wrapper">
        <el-table-column type="index" label="序号" width="180"></el-table-column>
        <el-table-column prop="lender" label="出借人" width="200" align="center"></el-table-column>
        <el-table-column prop="money" label="出借金额" align="center"></el-table-column>
        <el-table-column prop="date" label="出借时间" align="center"></el-table-column>
      </el-table>
    </template>
    <template v-else>
      <div class="table-wrapper no-data">
        暂无数据
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'lend-record',
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {
          baseInfo: {},
          recordList: []
        };
      }
    }
  },
  data() {
    return {
      // lendList: [
      //   {
      //     lender: '夏竹',
      //     money: '20,000.00',
      //     date: '2019-06-07  04:51:27'
      //   },
      //   {
      //     lender: '王多鱼',
      //     money: '20,000.00',
      //     date: '2019-06-07  04:51:27'
      //   }
      // ]
    };
  },
  computed: {
    lendList() {
      console.log(this.propsData.recordList);
      return this.propsData.recordList;
    },
    baseInfo() {
      return this.propsData.baseInfo;
    }
  }
};
</script>
<style lang="less" scoped>
.lend-record-wrapper {
  padding: 20px;
  .text-wrapper {
    display: flex;
    font-family: 'PingFangSC-Regular';
    font-size: 14px;
    color: #6a6a6a;
    .money {
      font-family: 'PingFangSC-Thin';
      color: #247af1;
    }
    .line {
      margin: 0 30px;
      color: #eff3ff;
    }
  }
  .table-wrapper {
    width: 100%;
    margin: 20px 0;
  }
  .no-data {
    min-height: 300px;
    line-height: 300px;
    font-size: 30px;
    text-align: center;
    color: #ccc;
  }
}
</style>
